import { render, staticRenderFns } from "./SaleInfo.vue?vue&type=template&id=a23dc284&"
import script from "./SaleInfo.vue?vue&type=script&lang=js&"
export * from "./SaleInfo.vue?vue&type=script&lang=js&"
import style0 from "./SaleInfo.vue?vue&type=style&index=0&id=a23dc284&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports